import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";

const MARKETS = [
  { city: "Mumbai", pop: "21.6M", note: "Western India HQ" },
  { city: "Delhi NCR", pop: "32.9M", note: "Northern India hub" },
  { city: "Bengaluru", pop: "13.6M", note: "Tech belt" },
  { city: "Hyderabad", pop: "10.5M", note: "South-Central" },
  { city: "Chennai", pop: "11.5M", note: "Southern coast" },
  { city: "Kolkata", pop: "15.3M", note: "Eastern India" },
  { city: "Pune", pop: "7.4M", note: "Education + IT" },
  { city: "Ahmedabad", pop: "8.6M", note: "Western trade" },
  { city: "Jaipur", pop: "4.0M", note: "Rajasthan" },
  { city: "Lucknow", pop: "3.8M", note: "UP capital" },
  { city: "Chandigarh", pop: "1.2M", note: "Tri-City belt" },
  { city: "Surat", pop: "7.8M", note: "Industrial west" },
  { city: "Indore", pop: "3.3M", note: "Central India" },
  { city: "Coimbatore", pop: "2.2M", note: "Tamil Nadu" },
  { city: "Goa", pop: "1.5M", note: "Leisure market" },
  { city: "Guwahati", pop: "1.1M", note: "North-East gateway" },
];

const Markets = () => {
  return (
    <main>
      <section className="relative bg-black text-white pt-40 pb-20 md:pt-48 md:pb-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <p className="text-[11px] uppercase tracking-[0.32em] text-white/60 mb-6">Markets</p>
          <h1 className="font-display text-[14vw] md:text-[8vw] uppercase leading-[0.92]">
            One brand. <br />
            <span className="font-serif-display italic font-black">Twenty-eight</span> cities.
          </h1>
          <p className="mt-8 max-w-2xl text-white/75 text-lg leading-relaxed">
            AMS operates a Pan-India network spanning metros, tier-1 and high
            growth tier-2 markets — with premium inventory in every corridor that
            matters.
          </p>
        </div>
      </section>

      <section className="bg-white text-black">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32">
          <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-black/10">
            {MARKETS.map((m, i) => (
              <li
                key={m.city}
                className="group bg-white p-8 hover:bg-black hover:text-white transition-colors duration-300 cursor-pointer"
              >
                <div className="flex items-start justify-between">
                  <span className="text-[11px] uppercase tracking-[0.3em] opacity-50">
                    0{i < 9 ? i + 1 : i + 1}
                  </span>
                  <MapPin className="w-4 h-4 opacity-50 group-hover:opacity-100 transition-opacity" />
                </div>
                <h3 className="font-display text-5xl md:text-6xl uppercase leading-none mt-6">
                  {m.city}
                </h3>
                <div className="mt-6 flex items-center justify-between text-[11px] uppercase tracking-[0.24em]">
                  <span className="opacity-65">Pop. {m.pop}</span>
                  <span className="opacity-65">{m.note}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="bg-neutral-50 text-black">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28 flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <h3 className="font-display text-[10vw] md:text-[5.6vw] uppercase leading-[0.92]">
            Tell us where <span className="font-serif-display italic font-black">to go.</span>
          </h3>
          <Link
            to="/contact"
            className="inline-flex items-center gap-3 text-sm uppercase tracking-[0.22em] font-semibold px-7 py-4 border border-black hover:bg-black hover:text-white transition-colors duration-200"
          >
            Plan a Route <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </main>
  );
};

export default Markets;
